import TemplateHelper from '../modules/template-helper';
import delegateListener from '../modules/delegate-listener';
import MediaItem from '../api/mediaitem';
import Item from '../api/item';

class ArchiveModal {

  constructor(options = {}) {
    const defaults = {
      openersParent: '.invoice-verification__table tbody',
      openerSelector: '[data-modal-target^="archive-event--"]',
      enabledPages: ['.page--pre-storage-events'],
      modalTemplate: 'pre-storage-event-archive-modal',
      templateHelper: new TemplateHelper(),
    };

    Object.assign(this, defaults, options);
  }

  /**
   * Attaches events if currently on an enabled page
   */
  init() {
    if(document.querySelectorAll(this.enabledPages.join(',')).length <= 0) {
      // short circuit initialization, as we're on a page that doesn't need this module.
      return;
    }

    // This should run before ModalHelpers' delegated click handler
    document.body.addEventListener('click',
      delegateListener(this.openerSelector, this.handleModalOpenerClick.bind(this))
    );

    if(typeof window.PRE_STORAGE_EVENT_TRANSLATIONS !== 'undefined') {
      this._translations = window.PRE_STORAGE_EVENT_TRANSLATIONS;
    }
  }

  /**
   * Finds the target's pid and ensures a corresponding modal exists in DOM.
   *
   * @param {Event} event - The handled event
   */
  handleModalOpenerClick(event) {
    const opener = event.delegateTarget || event.currentTarget;
    let modalTarget = opener.dataset.modalTarget;
    let id = parseInt(modalTarget.match(/\d+/g)[0]);
    this.openModal(id);
  }

  /**
   * Opens a given modal. Creates it if necessary.
   *
   * @param {Number} id - The target's pid
   *
   * @returns {HTMLElement} - The target's modal
   */
  openModal(id) {
    if(typeof this._modals === 'undefined') {
      this._modals = {};
    }
    if(typeof this._modals[id] === 'undefined') {
      return this._modals[id] = this.createModal(id);
    } else {
      return this._modals[id];
    }
  }

  /**
   * Creates and inserts a modal into the DOM
   *
   * @param {int} id - Target id
   *
   * @returns {HTMLElement} - The generated modal element
   */
  createModal(id) {
    let view = {
      modal_name: `archive-event--${id}`,
      storage_event_pid: id,
      reason: {
        textareaId: `reason--${id}`,
        textareaName: 'reason',
        textareaValue: '',
        title: this._translations.reason,
      }
    };

    const element = this.templateHelper.render(
      this.modalTemplate,
      view,
      document.body,
      'append',
      ['textarea']
    );

    return element;
  }
}

class PreStorageEventView {
  constructor(options = {}) {
    const defaults = {
      enabledPages: ['.page--pre-storage-event'],
      deleteMediaButtonSelector: '[data-remove-media]',
      mediaItemSelector: '.thumbnail-list__item'
    };

    Object.assign(this, defaults, options);
  }

  /**
   * Attaches events if currently on an enabled page
   */
  init() {
    if(document.querySelectorAll(this.enabledPages.join(',')).length <= 0) {
      // short circuit initialization, as we're on a page that doesn't need this module.
      return;
    }

    document.body.addEventListener(
      'click', delegateListener(
        this.deleteMediaButtonSelector,
        this._handleDeleteMediaClick.bind(this)
      )
    );

    if(document.querySelector('.js-move-to-sjoberg-nurmijarvi')) {
      document.querySelector('.js-move-to-sjoberg-nurmijarvi').addEventListener('click', this._moveToSjobergNurmijarvi.bind(this));
    }
  }

  /**
   * Event handler for delete media item button
   *
   * @param {Event} event - The click event
   */
  _handleDeleteMediaClick(event) {
    // Find target mediaId
    const mediaId = event.delegateTarget.dataset.removeMedia;
    if(!mediaId) { throw Error('MediaID not found'); }

    const mediaItem = new MediaItem(mediaId);
    const res = mediaItem.delete();
    res.then(response => {
      if(response.status === 'OK') {
        this._removeMediaItem(mediaId);
      } else {
        // TODO: indicate failure to user
      }
    });
  }

  /**
   * Removes a MediaItem's thumbnail from DOM
   *
   * @param {string} mediaId - The mediaId to be removed
   */
  _removeMediaItem(mediaId) {
    const oldItem = Array.from(
      document.querySelectorAll(this.mediaItemSelector)
    ).filter(item => {
      return item.dataset.itemId === mediaId;
    })[0];

    if(oldItem) {
      oldItem.parentNode.removeChild(oldItem);
    }
  }

  _moveToSjobergNurmijarvi() {
    const shouldContinue = confirm('Siirrä ennakkokirjaus varastolle Sjöberg Nurmijärvi?');
    if(!shouldContinue) return;

    const item = new Item(window.ITEM_ID);

    const data = {
      toSjobergNurmijarvi: true,
    };

    item.updateLocationSjoberg(data).then(response => {
      if(response.status === 'OK') {
        window.location.href = '/';
      }
    });
  }
}

module.exports = {
  ArchiveModal,
  PreStorageEventView
};
